{
	"backToManageDeclarations": "Volver a Gestionar declaraciones",
	"kpi": {
		"quantity": "Cantidad",
		"carbonSavings": "Reducciones de carbono"
	},
	"downloadAllDeclarations": "Descargar todas las declaraciones",
	"errors": {
		"notFound": "Proyecto no encontrado"
	}
}
